var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6.75C8.30109 6.75 8.11032 6.82902 7.96967 6.96967C7.82902 7.11032 7.75 7.30109 7.75 7.5V24.5C7.75 24.6989 7.82902 24.8897 7.96967 25.0303C8.11032 25.171 8.30109 25.25 8.5 25.25H23.5C23.6989 25.25 23.8897 25.171 24.0303 25.0303C24.171 24.8897 24.25 24.6989 24.25 24.5V11.75H26.75V24.5C26.75 25.362 26.4076 26.1886 25.7981 26.7981C25.1886 27.4076 24.362 27.75 23.5 27.75H8.5C7.63805 27.75 6.8114 27.4076 6.2019 26.7981C5.59241 26.1886 5.25 25.362 5.25 24.5V7.5C5.25 6.63805 5.59241 5.8114 6.2019 5.2019C6.8114 4.59241 7.63805 4.25 8.5 4.25H22.75V6.75H8.5Z",
    fill: "#00842F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8792 3.23218L29.7678 7.12085L19.5106 17.3792L13.0288 19.9712L15.6208 13.4894L25.8792 3.23218ZM17.7515 14.8943L17.5154 15.4846L18.1057 15.2486L26.2324 7.12094L25.8791 6.76762L17.7515 14.8943Z",
    fill: "#00842F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8228 4.82288C27.8228 4.82291 27.8228 4.82284 27.8228 4.82288L27.6463 4.99958L28.0003 5.35364L28.177 5.17711C28.1771 5.17706 28.177 5.17716 28.177 5.17711C28.2002 5.15389 28.2188 5.12618 28.2313 5.09585C28.2439 5.06546 28.2504 5.03288 28.2504 4.99999C28.2504 4.9671 28.2439 4.93453 28.2313 4.90414C28.2187 4.87374 28.2003 4.84613 28.177 4.82288C28.1538 4.79962 28.1262 4.78117 28.0958 4.76858C28.0654 4.75599 28.0328 4.74951 27.9999 4.74951C27.9335 4.74951 27.8698 4.77597 27.8228 4.82288ZM26.055 3.05511C26.5709 2.53929 27.2705 2.24951 27.9999 2.24951C28.3611 2.24951 28.7188 2.32065 29.0525 2.45888C29.3862 2.5971 29.6894 2.7997 29.9448 3.05511C30.2002 3.31052 30.4028 3.61373 30.541 3.94743C30.6793 4.28113 30.7504 4.63879 30.7504 4.99999C30.7504 5.36119 30.6793 5.71885 30.541 6.05256C30.4028 6.38625 30.2002 6.68947 29.9448 6.94488L27.9995 8.88834L24.1116 5.00041L26.055 3.05511Z",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b773a8ea.svg";
export { ForwardRef as ReactComponent };